<template>
    <div class="range-picker d-flex" style="width: 100%">
        <div class="d-flex align-baseline" style="width: 100%" :class="{'justify-space-between': periodName, 'justify-end': !periodName}">
            <div class="select-wrapper" v-if="periodName" style="width: 35%;">
                <v-select
                    hide-details 
                    :solo="solo"
                    :items="presets"
                    v-model="$store.state[storeName][periodName]"
                    label="Periode"
                    class="mr-4"
                    :disabled="disabled"
                />
            </div>
            <div class="menu-wrapper" :style="periodName ? 'width: 65%' : 'width: 100%'">
                <v-menu
                    offset-y
                    v-model="menu"
                    :close-on-content-click="false"
                    @click="menuCounter = 0"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            hide-details 
                            :solo="solo"
                            :disabled="disabled"
                            autocomplete="off"
                            v-model="rangeText"
                            readonly
                            v-on="on"
                            append-icon="fa-calendar-day"
                            color="red"
                        />
                    </template>
                    <v-date-picker
                        no-title
                        :first-day-of-week="1"
                        v-model="$store.state[storeName][rangeName]"
                        range
                        locale="da"
                        @input="handleDateInput"
                    />
                </v-menu>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
moment.locale('da')

export default {
    props: ['storeName', 'rangeName', 'periodName', 'presets', 'disabled', 'solo'],
    data () {
        return {
            menu: false,
            startDate: 0
        }
    },
    computed: {
        range: {
            get: function () {
                return this.$store.state[this.storeName][this.rangeName]
            }
        },
        rangeText: {
            get: function () {
                return this.$store.state[this.storeName][this.rangeName].reduce((rangeString, dateString, index) => {
                    rangeString += moment(dateString).format('D. MMMM YYYY')
                    if (index === 0) {
                        rangeString += ' - '
                    }
                    return rangeString
                }, '')
            },
            set: function () {
            }
        },
    },
    methods: {
        formatDate (date) {
            return moment(date).format('YYYY-MM-DD')
        },
        handleDateInput ({ length }) {
            if (length > 1) {
                this.$store.state[this.storeName][this.periodName] = 'Selvvalgt'
                this.menu = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
i {
    color: #FB3640 !important;
}
</style>